export enum Periodicity {
  MONTHLY = 'Mensal',
  QUARTERLY = 'Trimestral',
  SEMI_ANNUAL = 'Semestral',
  ANNUAL = 'Anual',
  APERIODIC = 'Aperiódica',
}